export default "/images/f6338765cf53d59a35518d701585a48b.avif";